/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { Box } from '@atlaskit/primitives/compiled';

import { useCommentContext } from './CommentContextProvider.tsx';

const AkCommentContent = () => {
	const { content, commentId } = useCommentContext();

	return (
		<Box
			testId={`issue-comment-base.ui.comment.ak-comment.${commentId}.content`}
			paddingBlock="space.075"
		>
			{content}
		</Box>
	);
};

export default AkCommentContent;
